"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = exports.DEFAULT_HEADER_HEIGHT = exports.MOBILE_HEADER_HEIGHT = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const errorBoundary_1 = __importDefault(require("./components/errorBoundary"));
const errorHeader_1 = __importDefault(require("./components/errorHeader"));
const header_1 = __importDefault(require("./components/header"));
const useCulture_1 = require("./hooks/useCulture");
const useHomepage_1 = require("./hooks/useHomepage");
const useRouting_1 = require("./hooks/useRouting");
const useTracking_1 = require("./hooks/useTracking");
const useTransparency_1 = require("./hooks/useTransparency");
var constants_1 = require("./constants");
Object.defineProperty(exports, "MOBILE_HEADER_HEIGHT", { enumerable: true, get: function () { return constants_1.MOBILE_HEADER_HEIGHT; } });
Object.defineProperty(exports, "DEFAULT_HEADER_HEIGHT", { enumerable: true, get: function () { return constants_1.DEFAULT_HEADER_HEIGHT; } });
const Header = (props) => {
    const { highlight, i18n, isTransparent, routing, trackingConfig } = props;
    const _routing = Object.assign(Object.assign({}, exports.Header.defaultProps.routing), routing);
    return ((0, jsx_runtime_1.jsx)(useTracking_1.TrackingContext.Provider, { value: trackingConfig, children: (0, jsx_runtime_1.jsx)(useTransparency_1.TransparencyProvider, { value: isTransparent, children: (0, jsx_runtime_1.jsx)(useCulture_1.CultureContext.Provider, { value: i18n, children: (0, jsx_runtime_1.jsx)(useRouting_1.RoutingContext.Provider, { value: _routing, children: (0, jsx_runtime_1.jsx)(errorBoundary_1.default, { errorChildren: (0, jsx_runtime_1.jsx)(errorHeader_1.default, {}), children: (0, jsx_runtime_1.jsx)(useHomepage_1.HomepageProvider, { highlight: highlight, children: (0, jsx_runtime_1.jsx)(header_1.default, Object.assign({}, props)) }) }) }) }) }) }));
};
exports.Header = Header;
exports.Header.defaultProps = {
    i18n: {
        locale: 'fr-fr',
        siteId: 1,
    },
    isTransparent: false,
    routing: {
        domain: '',
        isExternal: false,
        patterns: {
            home: '/gr/home/:homeName',
            homeModule: '/gr/home/:homeName?part=:moduleName',
            operation: '/gr/catalog/:id',
            sponsorship: '/gr/sponsorship',
        },
        pushMethod: (url) => (window.location.href = url),
    },
    showMenu: true,
    showSearch: false,
    showSponsorship: false,
    showWhoWeAre: false,
    trackingConfig: {
        isOpenDoor: false,
        onTagClick: () => null,
    },
    uri: '/api/navigation/1',
};
exports.default = exports.Header;
